import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faBox, faTrophy, faTruck, faBullseye, faPlus } from '@fortawesome/free-solid-svg-icons';

const OrderReportTable = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const email = user.email;

  const [reportData, setReportData] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [salesreportData, setSalesReportData] = useState(null);
  const [formData, setFormData] = useState({
    email: email,
    details: [
      {
        duration: '',
        totalOrders: '',
        completedOrders: '',
        pendingOrders: '',
        topSellingProduct: '',
        salesTargetProgress: '',
        commissionEarned: '',
        customerVisitOutcome: ''
      }
    ]
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      details: [{ ...formData.details[0], [name]: value }]
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://citi-mobile-app.onrender.com/admin/add-sales-report', formData);
      if (response.data.success) {
        alert('Sales report added successfully!');
        setIsPopupVisible(false);
      }
    } catch (error) {
      console.error('Error submitting sales report:', error);
    }
  };

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await axios.post('https://citi-mobile-app.onrender.com/saleagent/order-report', { email });
        setReportData(response.data);
      } catch (error) {
        console.log('Error fetching order report:', error);
      }
    };

    fetchReport();
  }, [email]);

  useEffect(() => {
    const fetchSalesReport = async () => {
      try {
        const response = await axios.post('https://citi-mobile-app.onrender.com/saleagent/getorder-report', { email });
        setSalesReportData(response.data);
      } catch (error) {
        console.log('Error fetching sales report:', error);
      }
    };

    fetchSalesReport();
  }, [email]);

  if (!reportData || !salesreportData) {
    return <div>Loading...</div>; // Show a loading message while data is being fetched
  }

  return (
    <div className="mt-8 max-sm:mt-16 ">
      {/* Top Cards */}

      <h1 className="text-[#1E1E1E] font-bold mb-16 text-center sm:text-left">Customer List</h1>
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-8 max-sm:w-screen ">
        
        <div className="bg-white p-4 rounded-lg shadow text-center max-sm:w-[100%]">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-500 text-2xl" />
          <h5 className="text-lg mt-2">Total Sales</h5>
          <p className="text-3xl font-bold">₦{reportData.totalSales}</p>
        </div>



        <div className="bg-white p-4 rounded-lg shadow text-center">
          <FontAwesomeIcon icon={faTrophy} className="text-yellow-500 text-2xl" />
          <h5 className="text-lg mt-2">Top Selling Product</h5>
          <p  className="text-3xl font-bold">{reportData.topSellingProduct}</p>
        </div>

        <div className="bg-white p-4 rounded-lg shadow text-center">
          <FontAwesomeIcon icon={faBox} className="text-green-500 text-2xl" />
          <h5 className="text-lg mt-2">Total Orders</h5>
          <p className="text-3xl font-bold">{reportData.totalOrdersPlaced}</p>
        </div>

        <div className="bg-white p-4 rounded-lg shadow text-center">
          <FontAwesomeIcon icon={faTruck} className="text-purple-500 text-2xl" />
          <h5 className="text-lg mt-2">Order Completed</h5>
          <p className="text-3xl font-bold">{reportData.totalOrdersCompleted}</p>
        </div>

        <div className="bg-white p-4 rounded-lg shadow text-center">
          <FontAwesomeIcon icon={faBullseye} className="text-red-500 text-2xl" />
          <h5 className="text-lg mt-2">Order Pending</h5>
          <p className="text-3xl font-bold">{reportData.totalOrdersPending}</p>
        </div>
      </div>

      <button className="bg-blue-500 text-white p-3 rounded-lg mt-4" onClick={() => setIsPopupVisible(true)}>
        Add Sales Full Report
      </button>

      {/* Table */}
      <div className="mt-8 p-5 bg-white rounded-md overflow-x-auto">
        <h1 className="text-[#1E1E1E] font-bold mb-3">Customer List</h1>
        <table className="table-auto w-full border-collapse bg-white rounded-lg shadow">
          <thead className="bg-[#F8F8F8]">
            <tr>
              <th className="border p-2">No</th>
              <th className="border p-2">Key Information</th>
              {salesreportData.details.map((detail, index) => (
                <th key={index} className="border p-2">{detail.duration}</th>
              ))}
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border p-2">1</td>
              <td className="border p-2">Total Orders</td>
              {salesreportData.details.map((detail, index) => (
                <td key={index} className="border p-2">{detail.totalOrders}</td>
              ))}
              <td className="border p-2">View</td>
            </tr>
            <tr>
              <td className="border p-2">2</td>
              <td className="border p-2">Completed Orders</td>
              {salesreportData.details.map((detail, index) => (
                <td key={index} className="border p-2">{detail.completedOrders}</td>
              ))}
              <td className="border p-2">View</td>
            </tr>
            <tr>
              <td className="border p-2">3</td>
              <td className="border p-2">Pending Orders</td>
              {salesreportData.details.map((detail, index) => (
                <td key={index} className="border p-2">{detail.pendingOrders}</td>
              ))}
              <td className="border p-2">View</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Popup Form */}
      {isPopupVisible && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-full sm:w-1/2">
            <h2 className="text-xl mb-4">Sales Agent Report Template</h2>
            <form onSubmit={handleFormSubmit}>
              {/* Form Fields */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="duration">Duration</label>
                  <input
                    type="text"
                    name="duration"
                    value={formData.details[0].duration}
                    onChange={handleInputChange}
                    placeholder="Enter duration"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="totalOrders">Total Orders</label>
                  <input
                    type="text"
                    name="totalOrders"
                    value={formData.details[0].totalOrders}
                    onChange={handleInputChange}
                    placeholder="Total Orders"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="completedOrders">Completed Orders</label>
                  <input
                    type="text"
                    name="completedOrders"
                    value={formData.details[0].completedOrders}
                    onChange={handleInputChange}
                    placeholder="Completed Orders"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="pendingOrders">Pending Orders</label>
                  <input
                    type="text"
                    name="pendingOrders"
                    value={formData.details[0].pendingOrders}
                    onChange={handleInputChange}
                    placeholder="Pending Orders"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="topSellingProduct">Top Selling Product</label>
                  <input
                    type="text"
                    name="topSellingProduct"
                    value={formData.details[0].topSellingProduct}
                    onChange={handleInputChange}
                    placeholder="Top Selling Product"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="salesTargetProgress">Sales Target Progress</label>
                  <input
                    type="text"
                    name="salesTargetProgress"
                    value={formData.details[0].salesTargetProgress}
                    onChange={handleInputChange}
                    placeholder="Sales Target Progress"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="commissionEarned">Commission Earned</label>
                  <input
                    type="text"
                    name="commissionEarned"
                    value={formData.details[0].commissionEarned}
                    onChange={handleInputChange}
                    placeholder="Commission Earned"
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="customerVisitOutcome">Customer Visit Outcome</label>
                  <input
                    type="text"
                    name="customerVisitOutcome"
                    value={formData.details[0].customerVisitOutcome}
                    onChange={handleInputChange}
                    placeholder="Customer Visit Outcome"
                    className="border p-2 rounded w-full"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-4">
                <button type="button" className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setIsPopupVisible(false)}>
                  Cancel
                </button>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderReportTable;
